import startCase from "lodash.startcase"
import capitalize from "lodash.capitalize"

import { isEnum, getComponentByPath } from "@specs"

import {
  TYPE_SSN,
  TYPE_ENUM,
  TYPE_DATE,
  TYPE_TEXT,
  TYPE_EMAIL,
  TYPE_PHONE,
  TYPE_ARRAY,
  TYPE_STRING,
  TYPE_OBJECT,
  TYPE_COUNTRY,
  TYPE_ARRAY_ENUM,
} from "../../FormItem/types"

import getComponentInputs from "./getComponentInputs"

const FORMAT_TYPES_MAP = {
  ssn: TYPE_SSN,
  date: TYPE_DATE,
  email: TYPE_EMAIL,
  phone: TYPE_PHONE,
}

const PATTERN_FORMAT_MAP = {
  "^[0-9]{9,9}$": "ssn",
  "^[0-9]{0,20}$": "phone",
}


const getPlaceholder = example => {
  let placeholder = example ? `${example}` : ""
  placeholder = Array.isArray(example) ? `${example[0]}` : placeholder

  return placeholder
}


const getInput = (operation, {
  name,
  type,
  $ref,
  items,
  format,
  example,
  pattern,
  maxLength,
  minLength,
  minimum,
  maximum,
  isRequired,
  default: initialValue,
}) => {
  const isStringEnum = !!$ref && isEnum(operation, $ref)
  const isArrayOfEnums = !!items && isEnum(operation, items.$ref)
  const isNestedObject = !!$ref && !isStringEnum

  if (isNestedObject) {
    type = TYPE_OBJECT
    const schema = getComponentInputs(getInput, operation, $ref)

    return {
      required: isRequired || false,
      name,
      type,
      schema
    }
  }

  const label = startCase(name)

  format = format ? format : PATTERN_FORMAT_MAP[pattern]

  type = FORMAT_TYPES_MAP[format] || type || TYPE_STRING
  type = name.toLowerCase().includes(TYPE_COUNTRY) ? TYPE_COUNTRY : type
  type = items ? TYPE_ARRAY : type
  type = isStringEnum ? TYPE_ENUM : type
  type = isArrayOfEnums ? TYPE_ARRAY_ENUM : type
  type = maxLength && maxLength > 128 ? TYPE_TEXT : type

  const placeholder = getPlaceholder(example)

  let options
  const hasOptions = isStringEnum || isArrayOfEnums

  if (hasOptions) {
    const componentPath = items?.$ref || $ref
    const { enum: enumValues } = getComponentByPath(operation, componentPath)
    options = enumValues.map(value => ({
      label: capitalize(value),
      value
    }))
  }

  return {
    required: isRequired || false,
    name,
    type,
    label,
    options,
    placeholder,
    initialValue,
    maxLength,
    minLength,
    minimum,
    maximum,
  }
}

export default getInput
